import { Box, Center, Image, Modal, rem } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import missingPage from '@/assets/images/bg-generic-error.webp'

import PlayIcon from './assets/play.svg' // Replace with your play icon
import styles from './styles.module.css'

interface YoutubeVideoProps {
  videoSrc: string // e.g. https://www.youtube.com/watch?v=xxxx
  aspectRatio?: number // default 16/9
  thumbnail?: string
  width?: number | string
  height?: number | string
  restStyle?: React.CSSProperties
}

function parseYoutubeVideoId(videoSrc?: string) {
  if (!videoSrc || !videoSrc?.trim()) return ''

  let matchResult = videoSrc.match(/youtube\.com\/watch\?v=([^&]*)/)
  let videoId = matchResult?.[1]
  if (videoId) return videoId

  matchResult = videoSrc.match(/youtu\.be\/([^?]*)/)
  videoId = matchResult?.[1]
  if (videoId) return videoId

  matchResult = videoSrc.match(/youtube\.com\/embed\/([^?]*)/)
  videoId = matchResult?.[1]

  return videoId || ''
}

export default function YoutubeVideo({
  videoSrc,
  aspectRatio = 16 / 9,
  thumbnail,
  width = 320,
  height = 180,
  restStyle,
}: YoutubeVideoProps) {
  const [opened, setOpened] = useState(false)
  const t = useTranslations('newsCommunity')
  const videoId = parseYoutubeVideoId(videoSrc)
  if (!videoSrc) return null

  // YouTube thumbnail
  const thumbUrl =
    thumbnail || (videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : missingPage.src)

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        centered
        size="auto"
        withCloseButton={false}
        onClick={e => {
          e.stopPropagation()
        }}
        styles={{
          body: { padding: 0, background: 'transparent' },
          content: { background: 'transparent', boxShadow: 'none' },
        }}
      >
        {videoId && (
          <Box style={{ width: '50vw', aspectRatio }}>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoId}`}
              title={t('youtubeVideoTitle')}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.youtubeIframe}
            />
          </Box>
        )}
      </Modal>
      <Box
        className={styles.youtubeBox}
        style={{
          width: typeof width === 'number' ? rem(width) : width,
          height: typeof height === 'number' ? rem(height) : height,
          ...restStyle,
        }}
        onClick={e => {
          e.stopPropagation()
          setOpened(true)
        }}
      >
        <Image
          src={thumbUrl}
          alt="Youtube Video"
          width="100%"
          height="100%"
          fit="cover"
          className={styles.youtubeImage}
        />
        {/* Gradient overlay */}
        <Box className={styles.youtubeGradient} />
        {/* Play button */}
        <Center className={styles.youtubePlayCenter}>
          <PlayIcon width={40} height={40} />
        </Center>
      </Box>
    </>
  )
}
